module.exports = __webpack_public_path__ + "img/20190418_154809_003.4f271edf.jpg";